import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Page } from "@/components/Page";
import { PageHeader } from "@/components/PageHeader";

/** The app's home page — a placeholder until there's an overview to show. */
export const Dashboard = () => {
  return (
    <Page>
      <PageHeader title="Dashboard" />
      <Box sx={{ px: 3 }}>
        <Typography color="text.secondary">Nothing here yet.</Typography>
      </Box>
    </Page>
  );
};
